import { NgxsModuleOptions } from '@ngxs/store';
import { UserState } from './states/user/user.state';
import { environment } from 'src/environments/environment';
import { NotificationState } from './states/notifications/notification.state';

export const STATES = [UserState, NotificationState];

export const OPTIONS_CONFIG: Partial<NgxsModuleOptions> = {
  developmentMode: !environment.production
};
